const $inject = ['$location', 'dataService', 'settingsService', 'microApiService'];

const lbaAddGridResourceCtrl = function ($location, dataService, settingsService, microApiService) {
  const vm = this;

  vm.fields = settingsService.settings.fields;
  vm.formErrors = false;
  dataService.data.activeItem = angular.copy(vm.settings.data);
  vm.data = dataService.data.activeItem;
  vm.indexArray = '';
  vm.waiting = false;
  vm.success = false;
  vm.cancel = cancel;
  vm.add = add;

  function cancel() {
    $location.path($location.$$path.slice(0, -3));
  }

  function add() {
    if (!vm.addGridResourceForm.$valid) {
      vm.formErrors = true;

      return false;
    }

    vm.waiting = true;

    if (vm.settings.microService) {
      console.log('MICRO');

    } else {


      dataService.post(vm.settings.endpoint, vm.data).then(data => {
        vm.waiting = false;
        vm.success = true;

        const locationPathTrimmed = $location.$$path.slice(0, -3);
        dataService.data.activeItem = undefined;
        if(vm.settings.continueEditPath){
          let actionPath = vm.settings.continueEditPath(data);
          $location.path(actionPath);
        }else{
          $location.path(locationPathTrimmed + data.Id);
        }
        
      });
    }
  }
};

lbaAddGridResourceCtrl.$inject = $inject;

export default lbaAddGridResourceCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaAddGridResource/lbaAddGridResourceCtrl.js